import React from "react";
import styled from 'styled-components/macro';
import { useResizeDetector } from 'react-resize-detector';
import { useRef, useEffect } from "react";
import {
	CSS_MOBILE_BREAKPOINT,
	CSS_LOWSCREEN_BREAKPOINT,
	CSS_COLOR_SELECTED,
	CSS_COLOR_BORDERS,
	CSS_PADDING_COMPACT,
	CSS_COLOR_TEXT_SECONDARY,
	CSS_COLOR_ACTION,
	CSS_COLOR_RED,
	CSS_SELECTOR_RADIUS,
	IMG_PREFIX,
	CSS_INPUT_RADIUS
} from '../constants';

import fullscreen from '../assets/big_fullscreen.svg';
import arrow_select_svg from '../assets/arrow_select.svg';
import arrow_svg from '../assets/arrow.svg';
import check_black_svg from '../assets/check_black.svg';
import check_white_svg from '../assets/check_white.svg';
import atg_device_png from '../assets/atg_device.png';
import { useState } from "react";

const CSS_SELECTOR_GAPS = '4px';


const SELECTOR_ARROW_WIDTH = 19;
const SELECTOR_ARROWS_WIDTH = 70;
const SELECTOR_ARROW_DURATION = 4000;
const SelectorArrowsStyled = styled.div`
	height: 36px;
	width: ${SELECTOR_ARROWS_WIDTH}px;
	position:relative;
	grid-area: arrows;

	transition: opacity 0.1s linear;
	&.unvisible {
		opacity: 0;
	}

	.arrow {
		height: 36px;
		width: ${SELECTOR_ARROW_WIDTH}px;
		background-repeat: no-repeat;
		background-image: url(${arrow_svg});
		position:absolute;
		top: 0;
		left: 0;
	    animation: animate ${SELECTOR_ARROW_DURATION}ms infinite;
		animation-timing-function: linear;
	}
	.arrow:nth-child(1){
    	animation-delay: -0s;
	}
	.arrow:nth-child(2){
    	animation-delay: -${SELECTOR_ARROW_DURATION/3}ms;
	}
	.arrow:nth-child(3){
    	animation-delay: -${SELECTOR_ARROW_DURATION/3*2}ms;
	}
	@keyframes animate {
	    0%{
	        opacity: 0;
	        transform: translate(0,0);
	    }
	    20%{
	        opacity: 1;
	    }
	    90%{
	        opacity: 1;
	    }
	    100%{
	        opacity: 0;
	        transform: translate(${SELECTOR_ARROWS_WIDTH-SELECTOR_ARROW_WIDTH}px,0);
	    }
	}
`;
const SelectorArrows = function({visible,animated}){
	// className={visible?'visible':'unvisible'}
	return (
		<SelectorArrowsStyled className="arrows">
		{visible&&<>
			<div className="arrow"></div>
			<div className="arrow"></div>
			<div className="arrow"></div>
		</>}
		</SelectorArrowsStyled>
	);
}


const INFOS_AREAS_MARGINS = '5px';
const SelectorStyled = styled.div`
	scroll-margin-bottom: 70px;
	@media ${CSS_MOBILE_BREAKPOINT} and ${CSS_LOWSCREEN_BREAKPOINT}{
		scroll-margin-bottom: 0;
	}
	&+&{
		margin-top: ${CSS_PADDING_COMPACT};
	}
	&.border-focused,&.border-standard {
		background: #fff;
		border-radius: 10px;
	}
	&.border-focused {
		border: 4px solid ${CSS_COLOR_SELECTED};
		padding: 10px;
	}
	&.border-standard {
		border: 1px solid ${CSS_COLOR_BORDERS};
		padding: 13px;
	}
	.inner-grid {
		display: grid;
		&.no-arrows {
			display: block;
		}
		grid-template-columns: ${SELECTOR_ARROWS_WIDTH}px auto;
		grid-template-rows: auto auto;
		column-gap: 6px;

		align-items: center;

		grid-template-areas:
    		"arrows options"
    		". infos";
		
		&:has(.special-area){
			grid-template-areas:
    		"arrows options"
    		"infos infos";
		}
	}
	&.with-buttons {
		.inner-grid {
			align-items: start;
		}
		.arrows {
			position: relative;
			top: 14px;
		}
	}
	h3 + .inner-grid {
		padding-top: 10px;
	}
	.options-area {
		grid-area: options;

		.special-area {
			padding-top: 10px;
			margin-left: -${SELECTOR_ARROWS_WIDTH+6}px;
			background-color: #fff;

			@media ${CSS_MOBILE_BREAKPOINT}{
				margin-left: 0px;
			}
		}

		.buttons {

			.button {
				font-weight:700;
				font-size: 28px;
				padding: 16px 2px;
				background-repeat: no-repeat;
				background-origin: border-box;
				background-size: 100% 100%;
				border: 2px solid rgba(0,0,0,0.2);
				text-align: center;
				color: #fff;
				border-radius: ${CSS_SELECTOR_RADIUS};
				cursor: pointer;
				user-select: none;
				-webkit-user-select: none;

				&.secondary {
					font-size: 24px;
				}

				u {
					white-space: nowrap;
				}

				background-image: linear-gradient(180deg, #49b1ff 0%, #0093ef 100%);
				&:hover {
					background-color: #E6E6E6;
					background-image: linear-gradient(180deg, #27a2ff 0%, #0084d6 100%);
					&.selected,&:active {
						background-image: linear-gradient(180deg, #0f7aca 0%, #0084d6 100%);
					}
				}

				&.secondary {
					background-image: linear-gradient(180deg, #fff 0%, #e6e6e6 100%);
					color:#555;
					padding: 10px 2px;
					&:hover {
						background-color: #E6E6E6;
						background-image: linear-gradient(180deg, #E6E6E6 0%, #D1D1D1 100%);
						&.selected,&:active {
							background-image: linear-gradient(180deg, #B7B7B7 0%, #D1D1D1 100%);
						}
					}
				}

				&+.button {
					margin-top: ${CSS_SELECTOR_GAPS};
				}
			}
		}

		.selectables {
			display: flex;
			&.colors {
				display: grid;
				grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
				column-gap: ${CSS_SELECTOR_GAPS};
				row-gap: ${CSS_SELECTOR_GAPS};
				.selectable {
					border-radius: ${CSS_SELECTOR_RADIUS};
					background-image:none;
					&+.selectable {
						margin-left: 0;
					}
				}
				&.line-of-4 {
					grid-template-columns: 1fr 1fr 1fr 1fr;
				}
			}
			.selectable {
				flex: 1 0 0;
				text-align: center;
				&+.selectable {
					margin-left: ${CSS_SELECTOR_GAPS};
				}

				padding: 2px;
				background-repeat: no-repeat;
				background-origin: border-box;
				background-size: 100% 100%;
				border: 2px solid rgba(0,0,0,0.2);
				background-image: linear-gradient(180deg, #fff 0%, #e6e6e6 100%);

				&:first-child {
					border-top-left-radius: ${CSS_SELECTOR_RADIUS};
					border-bottom-left-radius: ${CSS_SELECTOR_RADIUS};
				}
				&:last-child {
					border-top-right-radius: ${CSS_SELECTOR_RADIUS};
					border-bottom-right-radius: ${CSS_SELECTOR_RADIUS};
				}

				.text-holder {
					font-size: 22px;
					font-weight: 500;
					color:#555;
					padding: 7px 0;

					small {
						font-size: 80%;
					}
				}
				.color-holder {
					position: relative;
					height:50px;

					color:#fff;
					&.clear {
						color:#222;
					}
					.color-value {
						position: absolute;
						left: 0;
						right: 0;
						bottom: 6px;
						z-index: 1;
						overflow: hidden;
					}
					.color-box {
						position: absolute;
						top: 2px;
						left: 2px;
						right: 2px;
						bottom: 2px;
						border-radius: 2px;
						background-position: right 14px top 13px;
						background-size: 0px;
						background-repeat: no-repeat;
						transition: background-size 0.2s ease-out 0s, background-position 0.2s ease-out 0s;
					}
					.color-infobox {
						position: absolute;
						color: #222;
						left: -10px;
						right: -10px;
						top: 48px;
						background: #fff;
						border-radius: 2px;
						border: 1px solid #000;
						padding: 2px;
						display: none;
						z-index: 20;
					}
				}
				&.selected .color-holder {
					.color-value {
						font-weight: 700;
					}
					.color-box {
						background-image: url(${check_white_svg});
						background-position: right 4px top 3px;
						background-size: 20px;
					}
					&.clear {
						.color-box {
							background-image: url(${check_black_svg});
						}
					}
				}



				svg {
					margin: 5px 0;
				}


				&.displayed {
					border-color: #4b94ba;
				}
				&.selected,&:active {
					background-image: linear-gradient(180deg, #cfcfcf 0%, #f7f7f7 100%);
				}
				&.selected {
					padding: 0;
					border-width: 4px;
					border-color: ${CSS_COLOR_SELECTED};
				}

				&,* {
					cursor: pointer;
					user-select: none;
					-webkit-user-select: none;
				}

				&:hover {
					background-color: #E6E6E6;
					background-image: linear-gradient(180deg, #E6E6E6 0%, #D1D1D1 100%);
					&.selected,&:active {
						background-image: linear-gradient(180deg, #B7B7B7 0%, #D1D1D1 100%);
					}
					.color-holder {
						.color-infobox {
							display: block;
						}
					}
				}
			}
		}
	}
	.bullet {
		border-radius: 50%;
		color: #fff;
		text-align: center;
		background-color: #5c0fb1;
		width: 24px;
		height: 24px;
		line-height: 24px;
		font-size: 16px;
		font-weight: 500;
	}
	.bullet.option {
		background-color: #15B06D;
	}
	.infos-area {
		grid-area: infos;
		background-color: #f3f3f3;
		padding: ${CSS_PADDING_COMPACT};
		margin-top: ${CSS_PADDING_COMPACT};
		border-radius: 4px;
		font-size: 15px;
		line-height:1.1;
		color: #555555;
		.bullet {
			width: 16px;
			height: 16px;
			line-height: 16px;
			font-size: 13px;
			display: inline-block;
			margin-left: 4px;
		}
		td {
			padding: 0 ${CSS_PADDING_COMPACT} 0 0;
		}
		table,p {
			margin-top: ${INFOS_AREAS_MARGINS};
			&:first-child{
				margin-top: 0;
			}
		}
		a {
			color: ${CSS_COLOR_ACTION};
			text-decoration: none;
		}
		i, u, .nowrap {
			white-space: nowrap;
			font-style: normal;
		}
		b {
			font-weight: 700;
		}
		u {
			text-decoration: underline;
		}
		.purple {
			color: #5c0fb1;
		}
		.red {
			color: ${CSS_COLOR_RED};
		}

		.atg-device {
			background-image: url(${atg_device_png});
			background-position: left 0px top 50%;
			background-size: 120px;
			min-height: 120px;
			padding-left: 130px;
			background-repeat: no-repeat;
			display: flex;
			flex-direction: column;
			justify-content: center;
		}
	}

	.optional-accesories-images {
		.optional-accesories-image {
			height: 0;
			position: relative;
			background-size: cover;
		}
		.bullet {
			display: block;
			position: absolute;
			translate: -12px -12px;
		}
		.optional-accesories-image.A {
			background-image: url(${IMG_PREFIX+'optional_accessories-A.png,w=640'});
			padding-bottom: 62.4%;
		}
		.optional-accesories-image.B {
			background-image: url(${IMG_PREFIX+'optional_accessories-B.png,w=640'});
			padding-bottom: 68.7%;
		}
	}

	h3.head {
		font-size: 18px;
		font-weight: 700;
		span {
			color: ${CSS_COLOR_TEXT_SECONDARY};
			font-weight: 300;
		}
		sup {
			font-size: 75%;
			line-height: 0;
			position: relative;
			vertical-align: baseline;
			top: -0.5em;
		}
		small {
			font-size: 80%;
			font-weight: normal;
		}
	}

	.select-block {
		display: grid;

		grid-template-columns: 90px 24px auto 60px;
		grid-template-rows: auto;
		column-gap: 6px;

		align-items: center;

		grid-template-areas: "image bullet text select";
		
		.image {
			height: 60px;
			position: relative;

			.image-inner {
				background-size: contain;
				box-sizing: content-box;
				height: 60px;
				width: 90px;
				top: 0;
				left: 0;
				position: absolute;
				transition: all 0.5s;
				border-color: transparent;

				/* .fullscreen {
					background-repeat: no-repeat;
					background-position: 50% 50%;
					left: 1px;
					bottom: 1px;
					position: absolute;
					background-image: url(${fullscreen});
					height: 16px;
					width: 16px;
					background-size: contain;
					opacity: 0.9;
					transition: all 0.5s;
				} */
			}
		}
		&:hover {
			.image-inner {
				z-index: 1000;
				height: 120px;
				width: 180px;
				border: 2px solid ${CSS_COLOR_ACTION};
				top:47px;
				left: -5px;
				border-radius: 2px;
				/* .fullscreen {
					opacity: 0.3;
				} */
			}
		}

		@media ${CSS_MOBILE_BREAKPOINT}{
			&:hover .image-inner {
				top:47px;
				left: 2px;
			}
		}

		.name {
			line-height: 13px;
		}
		small {
			font-size: 12px;
		}


		&+.select-block {
			border-top: 1px solid ${CSS_COLOR_BORDERS};
		}
	}
	select {
		background-color: #fff;
		color: #222;
		margin-bottom: 0;
		box-sizing: border-box;
		width: 100%;
		font-size: 18px;
		resize: none;
		height: 30px;
		width: 100%;
		display: block;
		top: 0;
		right: 0;
		border-radius: ${CSS_INPUT_RADIUS};
		border: 1px solid ${CSS_COLOR_BORDERS};
	}
	select {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		padding-right: 27px;
		padding-left: 10px;
		text-indent: .01px;
		background-image: url(${arrow_select_svg});
		background-repeat: no-repeat;
		background-position: right;
		text-align: left;
		font-size: 14px;
		font-weight: 500;
	}

	&.thin {
		h3.head {
			font-size: 16px;
		}
		&.with-buttons {
			.arrows {
				top: 8px;
			}
		}
		.infos-area {
			font-size: 14px;
			table,tbody,tr,td {
				display: block;
			}
			tr+tr {
				margin-top: ${INFOS_AREAS_MARGINS};
			}
			td+td {
				margin-top: 1px;
			}
		}
		.options-area {
			.buttons {
				.button {
					font-size: 18px;
					&.secondary {
						font-size: 16px;
					}
				}
			}
			.selectables {
				.selectable {
					.text-holder {
						font-size: 16px;
					}
					.color-value {
						font-size:14px;
					}
				}
			}
		}
	}


	@media (max-width: 500px) {
		.inner-grid {
			grid-template-columns: 1fr;
			grid-template-areas:
				"options"
	    		"infos";
			}
			.arrows {
				display: none;
			}
		}
	}
	@media (max-width: 350px) {
		.inner-grid {
			.options-area {
				overflow-x: scroll;
			}
			.color-infobox {
				display: none !important;
			}
		}
	}

	@media ${CSS_MOBILE_BREAKPOINT}{

	}
`;

function Selector({
	type,//'images', 'texts', 'colors', 'buttons'
	options,//array of image, strings, or colors, with their associated value, [display:,value:]
	selected_id,//used by onSelection
	selected_value,//add a blue border to show it is selected
	className,//css
	disable_border,//usefull for custom shapes
	head_number,//1, 2...
	head_text,//"Choissez la profondeur de votre abri"
	infos,//html for things like "Passages sous pannes..."
	focus_status,// past, present, future
	onSelection,//tell the Parent that option id / value has been clicked ex. func('height',value)
	auto_scroll = 'center',
	arrows = true,

	special_mode=false,
	special_mode_selected_values
}){

	const focused = focus_status === 'present';

	let default_special_state = false;
	let optional_accessories = [];
	if(special_mode === 'optional_accessories'){
		head_text = <>Accessoires de finition <small>optionnels</small></>;

		options = [false,true].map((v)=>{
			return {
				value:v,
				display:v?'Oui':'Non'
			};
		});
		
		default_special_state = special_mode_selected_values.optional_accessories||{
			enabled:false
		};

		optional_accessories = [
			{id:'num_BANDEAU_FAITAGE',name:'Bandeau de faîtage',image:special_mode_selected_values.wall_front?'Bandeau_de_Faitage_LP_ferme':'Bandeau_de_Faitage_LP_ouvert',num:1},
			{id:'num_FAITIERE_SOLIN',name:'Faîtière en solin',image:'Faitiere_en_Solin',num:2},
			{id:'num_RIVE_SOLIN',name:'Rive en solin',image:'Rive_en_Solin',num:3},
			{id:'num_RIVE_GDE',name:'Grande rive',image:'Grande_Rive',num:4},
			{id:'num_ANGLE_GD',name:'Grand angle',image:'Grand_Angle',num:5},
			{id:'num_REJET_EAU',name:'Rejet d\'eau',image:'Rejet_dEau',num:6}
		]
	}
	const [special_state,setSpecialState] = useState(default_special_state);
	if(special_mode === 'optional_accessories'){
		selected_value = special_state.enabled;
		infos = <>
			<p>{
				(selected_value || special_mode_selected_values.wall_left || special_mode_selected_values.wall_right)?(<>✅ Votre abri Abri-Tole.fr dispose <b className="purple">de série</b> de rive{selected_value?<span className="bullet">A</span>:false} et d'angles{selected_value?<span className="bullet">B</span>:false} avec chaque pignon commandé. Si vous souhaitez améliorer le rendu esthétique de votre abri, vous pouvez également lui ajouter des accessoires de finition optionnels (fixations comprises dans le prix).<br/>Longueur des accessoires : 2100 mm. Recouvrement à prévoir entre chaque accessoire : 100 mm.<br/> Pour un abri de {special_mode_selected_values.depth}.05 m de profondeur, prévoir {Math.ceil((special_mode_selected_values.depth+0.2)/2)} rives pour 1 pignon, ou {Math.ceil((special_mode_selected_values.depth+0.4))} rives pour 2 pignons.</>):(<>Si vous souhaitez améliorer le rendu esthétique de votre abri, vous pouvez lui ajouter des accessoires de finition optionnels.</>)
			}</p>
		</>;
	}

	const options_with_status = options.map((option,id)=>{
		const displayed = option.value === selected_value;
		const selected = displayed && (focus_status === 'past');
		return {
			...option,
			displayed: displayed,
			selected: selected,
			css_class: (selected?'selected':(displayed?'displayed':'standard'))
			//+(type==='texts'?' text':'')
		}
	});

	className = className||'';

	const border_class = disable_border?'border-none':(focused?'border-focused':'border-standard');

	const head = (Number.isInteger(head_number)&&(!!head_text))?<h3 className="head"><span>Étape {head_number} : </span>{head_text}</h3>:null;

	const selector_ref = useRef();
	const options_area_ref = useRef();
	const { width } = useResizeDetector({targetRef:options_area_ref});
	const thin_editor = (!width || width < 450);

	function select(value){
		if(special_mode){
			if(value.enabled){
				setSpecialState(value);
			}else{
				setSpecialState({
					enabled:false
				});
			}
		}
		onSelection(selected_id,value);
	}

	//const did_mount = useRef(false);
	useEffect(()=>{
		if(head_number !== 1 && auto_scroll && focus_status==='present' && selector_ref.current){
			// Problematic on mobile... à améliorer
			// window.setTimeout(()=>{
			// 	const target = selector_ref.current;
			// 	target.parentNode.parentNode.parentNode.scrollTo({
			// 		top:target.offsetTop-110,
			// 		left:0,
			// 		behavior:'smooth'
			// 	});
			// },200);

			// auto_scroll > nearest moins perturbant
			selector_ref.current.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
		}
	},[focus_status,auto_scroll,head_number]);

	return (
		<SelectorStyled className={className+' '+border_class+(thin_editor?' thin':'')+((type==='buttons'&&options_with_status.length>1)?' with-buttons':'')} ref={selector_ref}>
			{head}
			<div className={'inner-grid'+(arrows?'':' no-arrows')}>
				{arrows&&<SelectorArrows visible={focused} moving={focused} />}
				

				{(!special_mode && options_with_status.length>0)&&<div className="options-area" ref={options_area_ref}>
					{(type!=='buttons')?<div className={'selectables '+type+((type==='colors'&&options_with_status.length%4===0)?' line-of-4':'')}>
						{options_with_status.map((o,id)=><div key={id} onClick={()=>{select(o.value)}} className={'selectable '+o.css_class}>
							{type==='images'&&o.display}
							{type==='texts'&&<div className={'text-holder'}>
								{o.display}
							</div>}
							{type==='colors'&&<>
								<div className={'color-holder'+(o.display.clear?(' clear'):'')}>
									<div className={'color-box'} style={{backgroundColor: ('#'+('00000'+(o.display.rgb).toString(16)).substr(-6))}}>

									</div>
									<div className={'color-value'}>
										{o.display.ral}
									</div>
									<div className={'color-infobox'}>
										{o.display.color_text}
									</div>
								</div>
							</>}
						</div>)}
					</div>:<div className={'buttons'}>
						{options_with_status.map((o,id)=><div className={'button'+(o.value!==true?' secondary':'')} key={id} onClick={()=>{select(o.value)}}>
							{o.display}
						</div>)}
					</div>}
				</div>}


				{(special_mode === 'optional_accessories')&&(<div className="options-area" ref={options_area_ref}>
					<div className={'selectables texts'}>
						{options_with_status.map((o,id)=><div key={id} onClick={()=>{
							select({
								...special_state,
								enabled: o.value
							});
						}} className={'selectable '+(o.css_class)}>
							<div className={'text-holder'}>
								{o.display}
							</div>
						</div>)}
					</div>
					{special_state.enabled&&<div className="special-area">
						{optional_accessories.map((r,id)=>{
						return <div className="select-block" key={id}>
							<div className="image">
								<div className="image-inner" css={'background-image:url('+IMG_PREFIX+r.image+'-9010.png,h=120px)'}>
									<div className="fullscreen"></div>
								</div>
							</div>
							<div className="bullet option">{r.num}</div>
							<div className="name">{r.name} <br /><small>longueur 2100 mm</small></div>
							<select value={special_state[r.id]||'0'} onChange={(e)=>{
								select({
									...special_state,
									[r.id]: e.target.value
								});
							}}>
								{Array.from(Array(10).keys()).map((v,id)=>{
									return <option value={''+v} key={id}>{v}</option>
								})}
							</select>
						</div>
						})}
						<div className="optional-accesories-images">
							<div className="optional-accesories-image A">
								<span css={"top:12%;left:32.6%"} className="bullet option">1</span>
								<span css={"top:12%;left:73.1%"} className="bullet">A</span>
								<span css={"top:50%;left:5%"} className="bullet">B</span>
								<span css={"top:88.6%;left:57.7%"} className="bullet">B</span>
								<span css={"top:50%;left:94%"} className="bullet">B</span>
							</div>
							<div className="optional-accesories-image B">
								<span css={"top:8.5%;left:66%"} className="bullet option">2</span>
								<span css={"top:8.5%;left:24.2%"} className="bullet option">3</span>
								<span css={"top:73.1%;left:81.6%"} className="bullet option">4</span>
								<span css={"top:89.1%;left:69.4%"} className="bullet option">5</span>
								<span css={"top:89.6%;left:28.1%"} className="bullet option">6</span>
							</div>
						</div>
					</div>}
				</div>)}

				{infos&&<div className="infos-area">{infos}</div>}
			</div>
		</SelectorStyled>
	);
}

export default Selector;
